// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.icon-success {
    color: green;
    font-size: 16px !important;
}

.icon-error {
    color: red;
    font-size: 16px !important;
}

.icon-title {
    font-size: 16px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/CardAffinityGroups/new/modal-creation-steps.css"],"names":[],"mappings":";AACA;IACI,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["\n.icon-success {\n    color: green;\n    font-size: 16px !important;\n}\n\n.icon-error {\n    color: red;\n    font-size: 16px !important;\n}\n\n.icon-title {\n    font-size: 16px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
